var _rect, _rect2, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDmcPriorityPass = function SvgDmcPriorityPass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    x: 0.5,
    y: 0.5,
    fill: "#000",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 34.5,
    height: 34.5,
    x: 0.25,
    y: 0.25,
    stroke: "url(#DMC-PriorityPass_svg__a)",
    strokeOpacity: 0.7,
    strokeWidth: 0.5,
    rx: 8.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#827127",
    d: "M19.326 17.935c5.838 0 6.21-3.828 6.21-5.225 0-1.398-.372-5.21-6.21-5.21H16.16v19.132h-1.338V7.5l-4.82 1.37.25.834 2.112-.6V26.63h-2.9v.869h10.491v-.87h-2.902v-8.696zm-.488-9.567c3.349 0 3.795 3.024 3.795 4.342s-.446 4.355-3.795 4.355h-1.785V8.368z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#806A21",
    d: "M19.326 17.935c5.838 0 6.21-3.828 6.21-5.225 0-1.398-.372-5.21-6.21-5.21H16.16v19.132h-1.338V7.5l-4.82 1.37.25.834 2.112-.6V26.63h-2.9v.869h10.491v-.87h-2.902v-8.696zm-.488-9.567c3.349 0 3.795 3.024 3.795 4.342s-.446 4.355-3.795 4.355h-1.785V8.368z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#DMC-PriorityPass_svg__b)",
    fillOpacity: 0.25,
    d: "M19.326 17.935c5.838 0 6.21-3.828 6.21-5.225 0-1.398-.372-5.21-6.21-5.21H16.16v19.132h-1.338V7.5l-4.82 1.37.25.834 2.112-.6V26.63h-2.9v.869h10.491v-.87h-2.902v-8.696zm-.488-9.567c3.349 0 3.795 3.024 3.795 4.342s-.446 4.355-3.795 4.355h-1.785V8.368z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillOpacity: 0.25,
    d: "M19.326 17.935c5.838 0 6.21-3.828 6.21-5.225 0-1.398-.372-5.21-6.21-5.21H16.16v19.132h-1.338V7.5l-4.82 1.37.25.834 2.112-.6V26.63h-2.9v.869h10.491v-.87h-2.902v-8.696zm-.488-9.567c3.349 0 3.795 3.024 3.795 4.342s-.446 4.355-3.795 4.355h-1.785V8.368z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "DMC-PriorityPass_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 19.3965 -15.5859 0 17.5 8.103)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#9B8D52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DMC-PriorityPass_svg__a",
    x1: 37.36,
    x2: 2.91,
    y1: -0.291,
    y2: 41.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B8D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#DDD2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D8F54"
  })))));
};
export default SvgDmcPriorityPass;